import React, { useState } from "react";
import { api } from "@/lib/api";
import { demoCode, openDemo, clearDemoToken } from "@/lib/demo";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";

const PORTALS = [
  ["introducer", "Introducer portal"], ["lender", "Lender desk"], ["call-centre", "Call centre (manager)"],
  ["agent", "Call centre agent"], ["media", "Media partner"],
];

/** A slim floating bar on every demo portal: it's a demo, hop portals, put it all back, or leave. */
export function DemoBar() {
  const [busy, setBusy] = useState(false);
  const code = demoCode();

  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/demo/reset");
      toast.success("The demo is back to how it started");
      setTimeout(() => window.location.assign(data.home || "/introducer"), 600);
    } catch (e) { toast.error(e?.response?.data?.detail || "That didn't reset — try again"); setBusy(false); }
  };
  const go = async (p) => {
    setBusy(true);
    try { await openDemo(code, p); } catch { toast.error("That portal didn't open — try again"); setBusy(false); }
  };
  const exit = () => {
    clearDemoToken();
    window.location.assign(code ? `/demo?k=${encodeURIComponent(code)}` : "/");
  };

  return (
    <div className="demo-bar" data-testid="demo-bar" role="status">
      <span className="db-dot" aria-hidden="true" />
      <span className="db-t"><b>Demo</b><span className="db-sub"> · made-up data, nothing here contacts anyone</span></span>
      {code && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="db-btn" disabled={busy} data-testid="demo-bar-switch">Switch portal</button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="center" className="w-56" data-testid="demo-bar-menu">
            {PORTALS.map(([k, label]) => (
              <DropdownMenuItem key={k} onSelect={() => go(k)} data-testid={`demo-bar-go-${k}`}>{label}</DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
      <button className="db-btn" onClick={reset} disabled={busy} data-testid="demo-bar-reset">Reset demo data</button>
      <button className="db-btn ghost" onClick={exit} disabled={busy} data-testid="demo-bar-exit">Exit</button>
    </div>
  );
}

export default DemoBar;
